module.exports = fox._r("images/models/avatar.gif", __webpack_public_path__ + "images/models/avatar.gif");


//////////////////
// WEBPACK FOOTER
// ./images/models/avatar.gif
// module id = 18
// module chunks = 5